import qs from 'qs';

import { axiosInstance, requestConfig } from 'network/apis';

import { URL_AUTH, OAUTH2_CLIENT_ID, OAUTH2_CLIENT_SECRET, URL_SYSTEM } from "utils/constants";

export const callTokenRefresh = async (refreshToken) => {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
    };

    const data = {
        'client_id': OAUTH2_CLIENT_ID,
        'client_secret': OAUTH2_CLIENT_SECRET,
        'grant_type': 'refresh_token',
        'scope': 'Shop_Auth offline_access openid',
        'refresh_token': refreshToken,
    };

    return await axiosInstance.post('/connect/token', qs.stringify(data), { baseURL: URL_AUTH, headers });
    // return await axiosInstance(requestConfig('post', URL_AUTH, '/connect/token', data, headers));
};


export const callNoticePopup = async () => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, '/board/popup'));
};